module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAANElEQVQokWO0t/f8z0AGYIHSjFjk/uOTYyLHNgYGBoYhpBEWOPhCFqscxTaORgcWQHZ0AAAyfwnmDetI2wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/10c.png
// module id = LByi
// module chunks = 64